$(document).ready(function(){
$('.gift-idea-accessories-inner-blocks-accessories').not('.slick-initialized').slick({
    slidesToShow:4,
    slidesToScroll:1,
    autoplay: true,
    infinite:true,    
  	arrows: false,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 1199,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '160px',
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '80px',
      }
    },
      {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px',
      }
    },
      {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
      }
    } 
  ]
  }); 
}); 